import React, { useState } from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import AddIcon from '@atlaskit/icon/core/add';
import { ButtonItem, MenuGroup } from '@atlaskit/menu';
import { Popup } from '@atlaskit/popup';

import type { GlobalShortcutActionsItem } from '../../types';

import { messages } from './messages';

type ShortcutActionProps = {
	actions: GlobalShortcutActionsItem[];
};
export const ShortcutActionMenu = ({ actions }: ShortcutActionProps) => {
	const { formatMessage } = useIntl();
	const [isOpen, setIsOpen] = useState(false);

	return (
		<Popup
			shouldRenderToParent
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			placement="bottom-start"
			content={() => (
				<MenuGroup>
					{actions.map((action, index) => (
						<ButtonItem
							key={index}
							onClick={(e) => {
								e.preventDefault();
								action.onClick?.();
								setIsOpen(false);
							}}
						>
							{action.component}
						</ButtonItem>
					))}
				</MenuGroup>
			)}
			trigger={(triggerProps) => (
				<IconButton
					{...triggerProps}
					appearance="subtle"
					spacing="compact"
					icon={(props) => <AddIcon {...props} size="small" />}
					label={formatMessage(messages.shortcutActionOpenMenuLabel)}
					onClick={() => setIsOpen(true)}
				/>
			)}
		/>
	);
};
